<template>
    <v-card
        width="100%"
        class="pt-2 pl-2 pb-3 mb-2"
    >
        <div class="doc_detail" id="doc_list_area">
            <div class="doc_detail_title_box">
                <div class="doc_detail_title">
                        <a :href="decodeURIComponent(release.doc_url)" target="_blunk" >{{ release.doc_title }}</a>
                        <p class="cat_string">
                            <span class="category_tag" v-for="tag in view_tag(release.cat_list)" :key="tag">
                                {{ tag }}
                            </span>
                        </p>
            <div class="doc_company_name"><a href="#" v-on:click="opendialog(release.company_id,1)">{{ release.company_name }}</a></div>
            <span class="doc_list_item"><span>配信日時</span>:<span>{{ release.doc_date }}</span></span>
            <span class="doc_list_item"><span>転載</span>:<span v-if="release.reprint_num != null" class="reprint_link"><a href="#" v-on:click="opendialog(release.doc_id,3)">{{ release.reprint_num }}</a></span><span v-else>-</span></span>
            <span class="doc_list_item"><span>配信サイト</span>:<span>{{ release.media_title }}</span></span>
            <div>
              <ul class="detail_tag_ul" style="padding:5px!important;display:flex;flex-wrap:wrap">
               <li class="detail_tag_list" v-for="tag in view_tag(release.key_list)" :key="tag">
                <span class="detail_list_tag" v-cloak><a href="#" v-on:click="opendialog(tag,2)">{{ tag }}</a></span>
               </li>
              </ul>
            </div>
 
                 </div>
                 <div class="doc_detail_pv" style="padding:3px 10px">
                    <div>
                      <v-img
                        :src="`https://search.qlipper.jp/cont/docimg?doc_id=` + release.doc_id"
                        :aspect-ratio="16/9"
                        class="grey lighten-2"
                        style="text-align:end;"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                </div>
                    <div class="article_pv">{{ Number(release.ssum_pv).toLocaleString() }}pv<br><span style="font-weight: 100;font-size: 1.3rem;">({{ Number(release.doc_pv).toLocaleString() }})</span></div>
                </div>
            </div>
       </div>
    </v-card>

</template>
<script>
module.exports = {
    props : ["release"],
    methods : {
        view_tag: function(text) {
            if(text == null || text == '')
            {
                return null;
            }
            var tags = text.split(',');
            return tags;
        },
        opendialog : function(query,mode){
            this.$emit("dialog_open",{query:query,mode:mode});
        },
    }
}
</script>
